<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->
    <main-filter @getResult="setRows" is_read_text="الرسائل المقروءة" />
    <!-- <MainLoader v-if="loading"></MainLoader> -->
    <div class="fadeIn">
      <!-- Start Main Section -->
      <main class="row">
        <v-data-table
          class="elevation-1 thumb diff_table col-12"
          :headers="headers"
          :items="messages"
          :search="search"
          :loading="loading"
          :loading-text="$t('table.loadingData')"
          item-key="id"
          :items-per-page="paginations.items_per_page"
          hide-default-footer
        >
          <!-- ================== You Can use any slots you want ================== -->
          <!-- Select no data State -->

          <template v-slot:no-data>
            {{ $t("table.noData") }}
          </template>

          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>

          <!-- Start:: Users Routes -->

          <template v-slot:[`item.sent_at`]="{ item }">
            <div class="">
              <h3 class="tw-text-base" v-if="item.sent_at">
                {{ item.sent_at }}
              </h3>
              <h3 class="tw-text-base" v-else>لا يوجد</h3>
            </div>
          </template>
          <template v-slot:[`item.read_at`]="{ item }">
            <div class="">
              <h3 class="!tw-text-base" v-if="item.read_at">
                {{ item.read_at }}
              </h3>
              <h3 class="!tw-text-base" v-else>لا يوجد</h3>
            </div>
          </template>
          <template v-slot:[`item.content`]="{ item }">
            <div class="tw-line-clamp-2 tw-max-w-[150px]">
              {{ item.content }}
            </div>
          </template>

          <!-- <template v-slot:[`item.sent_at`]="{ item }">
            <div class="item">
              <p class="title">{{ item.send_at }}</p>
            </div>
          </template> -->
          <!-- <template v-slot:[`item.desc`]="{ item }">
                                <div class="item-with-img">
                                <p>{{ item.desc.slice(0, 40) }}...</p>
                                </div>
                            </template> -->

          <!-- Start:: Report Reason Modal Button -->
          <template v-slot:[`item.report_reason`]="{ item }">
            <v-icon class="show" small v-if="item.report_reason">
              fal fa-eye
            </v-icon>

            <span v-else>_</span>
          </template>
          <!-- End:: Report Reason Modal Button -->

          <!-- Select actions-->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="_actions d-flex">
              <v-icon
                class="show"
                v-if="!canEdit"
                small
                @click="replyMessage(item)"
              >
                fal fa-reply
              </v-icon>
              <v-icon
                class="delete"
                v-if="!canDelete"
                small
                @click="deleteItem(item)"
              >
                fal fa-trash
              </v-icon>
              <!-- <v-icon class="show" small @click="editItem(item)">
                                    fal fa-edit
                                </v-icon> -->
              <!-- <v-icon class="edit" small @click="editItem(item)">
                                    fal fa-edit
                                    </v-icon> -->
              <!-- <v-icon class="delete" small @click="deleteItem(item)">
                                    fal fa-trash
                                </v-icon> -->
            </div>
          </template>

          <!-- ======================== Start Top Section ======================== -->
          <template v-slot:top>
            <h3 class="title table-title">عدد الرسائل {{ statisticsItem }}</h3>
            <!-- Delete dialog -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">
                  {{ $t("table.deletedialog.areYouSure") }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm">
                    {{ $t("table.deletedialog.ok") }}
                  </v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">
                    {{ $t("table.deletedialog.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <!-- ======================== End Top Section ======================== -->
        </v-data-table>

        <template>
          <div class="pagination_container tw-text-center mb-5">
            <v-pagination
              v-model="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="6"
              @input="fetchData($event)"
            ></v-pagination>
          </div>
        </template>
      </main>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MainFilter from "../../../components/Filters/MainFilter.vue";

export default {
  components: {
    MainFilter,
  },
  data() {
    return {
      selectedMessage: null,

      messages: [],
      // ========== Statistics
      statisticsItem: null,
      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,
      reportReasonModalIsOpen: false,
      reportReasonToShow: null,

      // ========== Your Data
      rows: [], // injected in created

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 5,
      },

      // ========== Loading
      loading: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.messages.title"),
          disabled: false,
          href: "",
        },
        {
          text: this.$t("breadcrumb.messages.withService"),
          disabled: false,
          href: "",
        },
      ],
      filter: null,
    };
  },
  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "id",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "المرسل",
            align: "center",
            value: "name",
            sortable: true,
          },
          {
            text: "الخدمة المطلوبة",
            align: "center",
            value: "service.name",
          },
          {
            text: "تاريخ القراءة",
            align: "center",
            value: "read_at",
            sortable: true,
          },
          {
            text: "تاريخ الارسال",
            align: "center",
            value: "sent_at",
            sortable: true,
          },
          {
            text: "المحتوي",
            align: "center",
            value: "content",
            sortable: true,
          },
          {
            text: "الاجراءات",
            align: "center",
            value: "actions",
            sortable: true,
          },
        ];
      } else {
        return [
          {
            text: "id",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
  },
  methods: {
    replyMessage(item) {
      this.$router.push({ path: "/messages/reply/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `contact/${this.itemtoDelete.id}`,
      })
        .then((res) => {
          //   this.messages = this.messages.filter((item) => {
          //     return item.id != this.itemtoDelete.id
          //   })
          this.setRows();
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows(e) {
      this.loading = true;
      const params = new URLSearchParams();
      console.log(this.filter);
      if (e?.is_read) {
        params.append("is_read", e.is_read);
      }
      params.append("page", this.paginations.current_page);
      this.axios({
        method: "GET",
        url: "contact_service",
        params: params,
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta?.last_page;
          this.paginations.items_per_page = res.data.meta?.per_page;
          this.messages = res.data.data;
          this.statisticsItem = res.data.meta.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
  },
  created() {
    this.canEdit = this.$permission.allowed("messages/reply");
    this.canDelete = this.$permission.allowed("messages/delete");
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },
  mounted() {
    // this.setRows()
  },
};
</script>
<style lang="scss">
.selected_message {
  padding: 0px !important;
  padding-inline: 0;
  // width: 100%;
  height: 100vh;
  overflow: scroll;
  box-shadow: 0 2px 8px rgb(0 0 0 / 11%);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .show_message {
    text-align: center;
    // padding-block:10px ;
    font-size: 17px;
    .header {
      background: var(--mainColor-2);
      width: 100%;
      padding-inline: 10px;
      direction: ltr;
      display: flex;
      justify-content: space-between;
      margin-block-end: 15px;
      h3 {
        color: #fff;
        line-height: 40px;
        margin: 0;
      }
      .v-icon {
        color: #fff;
        margin-inline-start: 7px;
        line-height: 40px;
      }
    }
    a {
      color: var(--mainColor-2) !important;
    }
  }
  .message_content {
    border: 1px solid #eee;
    border-radius: 15px 15px 0px 15px;
    margin-block-start: 20px;
    margin-inline-start: 10px;
    padding: 5px 10px 0;
    text-align: center;
    background: #eee;
    width: fit-content;
  }
  .recent_messages {
    display: none;
  }
  span {
    font-size: 15px;
    text-align: right;
    display: inline-block;
    width: 100%;
    margin-inline-start: 10px;
  }
}
</style>
